<template>
  <div>
    <!-- <v-row class="mb-16">
      <v-col cols="12" md="12"> -->
    <!-- <v-card-title class="text-h4 font-weight-bold mb-4">
        {{ $t('sales.title') }}
    </v-card-title> -->
    <!-- 
      </v-col>
      <v-col cols="12">
        <template> -->
    <v-card color="" elevation="0" class="">
      <v-divider></v-divider>
      <template>
        <v-tabs
          color="primary"
          v-model="tabs"
          class=""
          height="80"
          background-color="#f4f4f4"
        >
          <div class="d-flex align-center px-4">
            <v-icon color="primary " size="">mdi-file-chart</v-icon>
            <h5 class="font-weight-bold headline ml-2">
              {{ $t("reports.title") }}
            </h5>
          </div>
          <v-tab class="ml-4">{{ $t("reports.support.title") }}</v-tab>
          <!-- <v-tab>{{ $t("sales.clientsList.stepTitle") }}</v-tab> -->
          <!-- <div class="d-flex align-center" v-if="!$root.auth.profile.whitelabelId">
            <v-tab disabled></v-tab>
            <v-chip x-small class="mb-2 mt-2 px-1 ml-n6" color="info"
              ><span class="black---text">{{
                $t("sales.clientsList.underDev")
              }}</span></v-chip
            >
          </div> -->
      
        </v-tabs>
      </template>

      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <SupportList></SupportList>
        </v-tab-item>
        
      </v-tabs-items>
    </v-card>
    <!-- </template>
      </v-col>

    </v-row>-->
  </div>
</template>

<script>
import SupportList from "@/components/reports/support/SupportList.vue";

export default {
  name: "ReportsView",
  components: { SupportList },
  data() {
    return {
      tabs: 0
    };
  },
  mounted() {
    this.loadTabs();
  },
  watch: {
    "$route.params.tab"() {
      this.loadTabs();
    },
    tabs(nV) {
      let query = [];
      for (let key in this.$route.query) {
        // if(nV != 0 && key == 'q')
        query.push(`${key}=${this.$route.query[key]}`);
      }
      const qstring = query.length ? `?${query.join("&")}` : "";
     

      if (nV == 0 && this.$route.path != "/reports/support"){
        this.$router.replace(`/reports/support${qstring}`);
      }
      // if (nV == 3 && this.$route.path != "/sales/commercial-policies"){
      //   this.$router.replace(`/sales/commercial-policies${qstring}`);
      // }
    },
  },
  methods: {
  
    loadTabs() {
      if (!this.$route.params.tab) {
        this.tabs = 0;
      } else {
        // if (this.$route.params.tab == "customers") {
        //   this.tabs = 1;
        // }
        if (this.$route.params.tab == "support") {
          this.tabs = 0;
        }
        // if (this.$route.params.tab == "reserved") {
        //   this.tabs = 2;
        // }
        // if (this.$route.params.tab == "commercial-policies") {
        //   this.tabs = 3;
        // }
      }
    }}}
</script>